/**
 * Created by rak on 4/28/2015.
 */

'use strict';

angular.module('dashboard.fleetMap', ['adf.provider'])
  .config(function (dashboardProvider) {
    dashboardProvider
      .widget('fleetMapWidget', {
        resolve: {
          title: function () {
            return 'dashBoard.fleetManagement.fleetMap.fleetMapTitle';
          },
          description: function () {
            return 'dashBoard.fleetManagement.fleetMap.description';
          }
        },
        controller: 'fleetMapCtrl',
        templateUrl: 'components/dashboard/fleetMap/fleetMapWidget.tpl.html',
        isSingleInstance: true,
        reload: true,
        config: {
          height: 600
        },
        edit: {
          templateUrl: 'components/dashboard/fleetMap/fleetMapEdit.tpl.html',
          reload: false,
          controller: 'fleetMapEditCtrl'
        }
      });
  }).service('fleetMapWidgetService', function () {
    var _isWidgetInitialized = false;
    this.isWigetInitialized = function () {
      return _isWidgetInitialized;
    };
    this.setWigetInitialized = function (value) {
      _isWidgetInitialized = value;
    };

  }).controller('fleetMapCtrl', function ($scope, AuthenticationService, $rootScope, $timeout, commonTrackService, config, fleetMapWidgetService, vehicleMapWidgetService, $window, localStorageService) {

    $scope.height = config.height;
    $scope.isWidgetPreInitFinished = false;
    $scope.isWidgetPostInitFinished = false;
    $scope.currentGroupId = vehicleMapWidgetService.getGroupId() || '';

    var loginid = AuthenticationService.GetLoginID();
    var localStroageInfoBalloonState = localStorageService.get('fleetMapInfoBalloonState.' + loginid.Account + '.' + loginid.username);
    $scope.fleetMap = {
      showDisplayBalloon: localStroageInfoBalloonState !== undefined && localStroageInfoBalloonState !== null ? localStroageInfoBalloonState : 1
    };
    $scope.height = fleetMapWidgetService.isWigetInitialized() ? $window.innerHeight - 200 : config.height;
    $scope.mapUrl = '';

    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
      });
    };
    loadFleetServerDetails().then(function () {
      fleetMapWidgetService.setWigetInitialized(true);
    }).finally(function () {
      // Request for the current Parent Widget data , Selected Row details etc ..  Desigined to be be called only at the initial Loading .
      $timeout(function () {
        $rootScope.$broadcast('fleetMap_req_current_context');
      }, 0, false);


    });


    // Event from the source widget vehicleGroup DropDown/Combobox
    var vehcileGroupChangedEvt = $scope.$on('vehicleGroupChanged', function (event, data) {
      if ($scope.isWidgetPostInitFinished) {
        var groupId = data.selectedVehicleGroup;
        if (!groupId) {
          groupId = vehicleMapWidgetService.getGroupId();
        }
        $scope.currentGroupId = groupId || '';
        
        if (groupId) {
          vehicleMapWidgetService.setGroupId(groupId);
        }

        if (groupId && groupId !== '' && $scope.fleetServerUrl) {
          $timeout(function () {
            $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, '&page=map.fleet.full&buildingSiteLocationBtn=true&group=' + groupId, 'fleetMap');
          }, 0);
        } else {
          $scope.mapUrl = 'components/dashboard/vehicleMap/404.html';
        }
      }

    });

    var restResponseErrorEvt = $scope.$on('rest-error-event', function (event, response) {
      if (response.data && response.data.errors && response.data.errors.length > 0 && response.data.errors[0].code) {
        if (response.data.errors[0].code === 'CM0020') {
          $scope.mapUrl = 'components/dashboard/vehicleMap/404.html';
        }
      }
    });


    // update events from some of the Parent Widgets
    $scope.$on('fleet-map-update', function (event, data) {
      if ($('.chat-window-container').length === 0) {
        commonTrackService.iframePostMessage('jsmShowDetailPushpin(' + data.pushPinIndex + ', 0 ,' + '"' + data.deviceId + '"' + ' ,' + $scope.fleetMap.showDisplayBalloon + ')', 'fleetMap');
      }
    });


    $scope.showInfoBalloonCheckBoxChange = function () {
      if ($('.chat-window-container').length === 0) {
        commonTrackService.iframePostMessage('jsmShowDetailPushpin(' + -1 + ', 0 ,' + '"' + null + '"' + ' ,' + $scope.fleetMap.showDisplayBalloon + ')', 'fleetMap');
        localStorageService.set('fleetMapInfoBalloonState.' + loginid.Account + '.' + loginid.username, $scope.fleetMap.showDisplayBalloon);
      }
    };


    // Response from current Parent Widget for the request event 'leetMap_req_current_context'
    /**
     * Try to get the parent selected  row / related  data if not avilable will try 20 times in the interval of 50 milli seconds each
     */
    var maxGetInitialDataRetries = 20;
    var currentSelectedGroupEvent = $scope.$on('fleetMap_res_current_context', function (event, data) {
      --maxGetInitialDataRetries;
      var serviceGroupId = vehicleMapWidgetService.getGroupId();
      var contextGroupId = data.vehicleGroup;
      var groupId = serviceGroupId || contextGroupId;
      
      $scope.currentGroupId = groupId || '';

      if (groupId && groupId !== '') {
        $scope.isWidgetPostInitFinished = true;
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, '&page=map.fleet.full&buildingSiteLocationBtn=true&group=' + groupId, 'fleetMap');
      } else {
        if (maxGetInitialDataRetries > 0) {
          $timeout(function () {
            $rootScope.$broadcast('fleetMap_req_current_context');
          }, 50);
        } else {
          console.warn('Max Retries exceeded to get the current Parent data for FleetMap widget');
          $scope.mapUrl = 'components/dashboard/vehicleMap/404.html';
          $scope.isWidgetPostInitFinished = true;
          currentSelectedGroupEvent();
        }
        // Repeatedly try to get the data from parent .
      }
    });

    $scope.$on('$destroy', function () {
      vehcileGroupChangedEvt();
      restResponseErrorEvt();
      currentSelectedGroupEvent();
    });

    $scope.fleetMapLoadEvent = function () {
      $scope.isWidgetPreInitFinished = true; // Pre init animation must disaaper
      //console.log('iframe "#fleetMap" loaded ....');
    };


  }).controller('fleetMapEditCtrl', function ($scope, config) {
    $scope.fleetMap = {
      height: config.height
    };
    $scope.$watch('fleetMap.height', function (height) {
      if (height) {
        config.height = height;
      }
    });
  });



// WEBPACK FOOTER //
// ./.tmp/components/dashboard/fleetMap/fleetMapWidget.js